import { useMemo, useState } from 'react';
import { JsonViewer as ViewJsonReact } from 'view-json-react';
import { Box, Button, Paper } from '@mui/material';
import { useLocalization } from '@ui-framework/index';

function JsonViewer({ json }) {
  const { formatMessage } = useLocalization();
  const [tab, setTab] = useState(0);

  const parsedJson = useMemo(() => {
    try {
      return JSON.parse(json);
    } catch {
      return json;
    }
  }, [json]);

  const rawJson = useMemo(
    () => JSON.stringify(parsedJson, null, 2),
    [parsedJson],
  );

  const treeLabel = formatMessage({
    id: 'TREE',
    defaultMessage: 'Tree',
  });
  const jsonLabel = formatMessage({
    id: 'JSON',
    defaultMessage: 'JSON',
  });

  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <Box
        sx={{
          display: 'flex',
          gap: 0.5,
          borderBottom: 1,
          borderColor: 'divider',
          px: 1,
          py: 0.5,
        }}>
        <Button
          role="tab"
          size="small"
          variant={tab === 0 ? 'contained' : 'text'}
          onClick={() => setTab(0)}>
          {treeLabel}
        </Button>
        <Button
          role="tab"
          size="small"
          variant={tab === 1 ? 'contained' : 'text'}
          onClick={() => setTab(1)}>
          {jsonLabel}
        </Button>
      </Box>

      {tab === 0 && (
        <Box
          sx={{
            p: 1.5,
            maxHeight: 'min(70vh, 720px)',
            overflow: 'auto',
          }}>
          <ViewJsonReact
            data={parsedJson}
            theme="light"
            defaultExpandDepth={3}
          />
        </Box>
      )}

      {tab === 1 && (
        <Box
          component="pre"
          sx={{
            m: 0,
            p: 2,
            maxHeight: 'min(70vh, 720px)',
            overflow: 'auto',
            fontSize: theme => theme.typography.caption.fontSize,
            fontFamily: 'ui-monospace, monospace',
          }}>
          {rawJson}
        </Box>
      )}
    </Paper>
  );
}

export default JsonViewer;
